import { render, staticRenderFns } from "./signup-overseas.vue?vue&type=template&id=8c93b81e&scoped=true"
import script from "./signup-overseas.vue?vue&type=script&lang=js"
export * from "./signup-overseas.vue?vue&type=script&lang=js"
import style0 from "./signup-overseas.vue?vue&type=style&index=0&id=8c93b81e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c93b81e",
  null
  
)

export default component.exports